<!-- ------------------------Компонент для додавання пошти ----------------------------------- -->
<template>
  <smallModal @eccape="$emit('close')">
    <div>
      <label for="new-email">{{ lang['Email'] }}</label>
      <b-form-input v-model="addEmail" autofocus class="email-input-settings" :state="checkEmail" />
    </div>
    <hr>
    <div class="buttons">
      <button class="btn btn-secondary" @click="$emit('close')">{{ lang['Сancel'] }}</button>
      <button class="btn btn-success" @click="saveEmail">{{ lang['Save'] }}</button>
    </div>
  </smallModal>
</template>

<script>
import smallModal from '../modals/smallModal'; // Компонент маленького модального вікна
import { regAPi } from '@/API.js';
import { store } from "@/store.js"; // Глобальне сховище даних

const apiList = new regAPi();
export default {
  components: {
    smallModal
  },
  data() {
    return {
      addEmail: ''
    }
  },
  methods: {
    saveEmail() {
      try {
        if (this.checkEmail) {
          apiList.addEmail({ token: store.token, email: this.addEmail }).then(resp => {
            if (resp.data.status == 'done') {
              this.$emit('close');
              window.say.message(this.lang['Saved']);
            } else if(resp.data.error[0] == 'Email is already registered') {
              window.say.messageError(this.lang['EmailAlreadyRegistered']);
            } else {
              window.say.messageError(this.lang['Error']);
            }
          })
        } else {
          window.say.messageError(this.lang['WrongFormat']);
        }
      } catch(err) {
          //
      }
    }
  },
  computed: {
    checkEmail() {
      const mailRegular  = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (mailRegular.test(this.addEmail) == false) return false;
      else return true;
    },
    // Мова додатку
    lang() {
      return window.lang;
    }
  }
}
</script>

<style scoped>
.buttons {
  display: flex;
  justify-content: space-between;
}

.btn-secondary, .btn-success {
  width: 49%;
}

.form-control.is-valid, .form-control.is-valid:focus {
  border-color: #00c279;
}

.form-control.is-valid {
  border-color: #00c279;
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='8' height='8' viewBox='0 0 8 8'%3e%3cpath fill='%2300C279' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3e%3c/svg%3e");
}

.form-control.is-invalid, .form-control.is-invalid:focus {
  border-color: #ff3548;
}

.form-control.is-invalid {
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='none' stroke='%23ff3548' viewBox='0 0 12 12'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23dc3545' stroke='none'/%3e%3c/svg%3e");
}


.btn-success {
  background-color: #00c279;
  border: none;
  text-transform: uppercase;
  font-size: 10pt;
}

.btn-success:not(:disabled):not(.disabled):active {
  background-color: #00B26F;
}

.btn-success:hover {
  background-color: #00B26F;
}

.btn-secondary {
  color: gray;
  background-color: white;
  border: none;
  text-transform: uppercase;
  font-size: 10pt;
}

.btn-secondary:not(:disabled):not(.disabled):active {
  background-color: white;
  color: gray;
}

.btn-secondary:hover {
  text-decoration: underline;
  color: gray;
  background-color: white;
}
</style>